export const buttonText = {
  freeConsulting: '無料相談',
  line: 'LINE問い合わせ',
  here: 'お問い合わせはこちら',
  more: '詳しく見る',
};
